/*
 * @Author: DT
 * @Date: 2022-07-22 11:19:52
 * @LastEditors: DT
 * @LastEditTime: 2022-07-22 11:20:45
 * @Description: file content
 * @FilePath: /yxdcommunity/src/views/limit/index.js
 */
// export { default as chainsDetail } from "./chainsDetail/chainsDetail.vue";
export const limitList = (r) => require.ensure([], () => r(require("./list/limit.vue")), "limitList");
